// extracted by mini-css-extract-plugin
export var brand = "_1i-9";
export var button = "_1i-0";
export var chevron = "_1i-v";
export var chevronButton = "_1i-w";
export var content = "_1i-n";
export var danger = "_1i-g";
export var dangerOutlined = "_1i-h";
export var dark = "_1i-l";
export var darkTheme = "_1i-c";
export var extraSmall = "_1i-4";
export var fullWidth = "_1i-8";
export var ghost = "_1i-d";
export var gray = "_1i-t";
export var icon = "_1i-p";
export var iconButton = "_1i-s";
export var iconButtonBorder = "_1i-x";
export var iconButtonBorderDark = "_1i-y";
export var iconButtonBorderLight = "_1i-z";
export var iconLeft = "_1i-q";
export var iconRight = "_1i-r";
export var large = "_1i-1";
export var light = "_1i-m";
export var medium = "_1i-2";
export var micro = "_1i-5";
export var nano = "_1i-7";
export var outlined = "_1i-k";
export var pending = "_1i-a";
export var primary = "_1i-i";
export var shadow = "_1i-o";
export var small = "_1i-3";
export var solidLight = "_1i-e";
export var solidLightBrand = "_1i-f";
export var spinner = "_1i-u";
export var transparent = "_1i-j";
export var warning = "_1i-b";
export var wideNano = "_1i-6";